<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="50" rx="20" :fill="getColor"/>
    <path class="call_stroke_hoverEffect" d="M23.1032 18.9632L26.2246 15.8418C27.2435 14.8229 28.6255 14.2505 30.0664 14.2505C31.5074 14.2505 32.8893 14.8229 33.9082 15.8418C34.9271 16.8607 35.4995 18.2426 35.4995 19.6836C35.4995 21.1245 34.9271 22.5065 33.9082 23.5254C32.7557 24.6779 31.347 26.0866 30.7867 26.6468" stroke="#80B7FF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="call_stroke_hoverEffect" d="M26.8968 30.5368L23.7754 33.6582C22.7565 34.6771 21.3745 35.2495 19.9336 35.2495C18.4926 35.2495 17.1107 34.6771 16.0918 33.6582C15.0729 32.6393 14.5005 31.2574 14.5005 29.8164C14.5005 28.3755 15.0729 26.9935 16.0918 25.9746C17.2443 24.8221 18.653 23.4134 19.2133 22.8532" stroke="#80B7FF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="call_stroke_hoverEffect" d="M29.2021 20.5488L20.5581 29.1929" stroke="#80B7FF" stroke-width="3" stroke-linecap="round"/>
  </svg>
</template>

<script>

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: null }
  },
  computed: {
    getColor(){
      if (!this.color)
        return document.getElementsByTagName('html')[0].getAttribute('theme') !== 'dark' ? '#fff' : '#161A21';
    }
  }
}
</script>
